import { Action, Selector, State, StateContext } from '@ngxs/store';
import { Injectable } from '@angular/core';
import {
  MarkMessagesAsUnread,
  ResetConversation,
  SetAdaEmbedAsLoaded,
  SetChatAsInitialized,
  UpdateAdaChatToggleState,
} from '@core/ada/store/actions/ada.actions';

interface AdaStateModel {
  isChatOpened: boolean;
  isAdaEmbedLoaded: boolean;
  hasUnreadMessages: boolean;
  isChatInitialized: boolean;
}

@State<AdaStateModel>({
  name: 'ada',
  defaults: {
    isChatOpened: false,
    isAdaEmbedLoaded: false,
    hasUnreadMessages: false,
    isChatInitialized: false,
  },
})
@Injectable()
export class AdaState {
  @Selector()
  static isChatOpened(state: AdaStateModel): boolean {
    return state.isChatOpened;
  }

  @Selector()
  static hasUnreadMessages(state: AdaStateModel): boolean {
    return state.hasUnreadMessages;
  }

  @Selector()
  static isAdaEmbedLoaded(state: AdaStateModel): boolean {
    return state.isAdaEmbedLoaded;
  }

  @Selector()
  static isChatInitialized(state: AdaStateModel): boolean {
    return state.isChatInitialized;
  }

  @Action(UpdateAdaChatToggleState)
  updateAdaChatToggleState(context: StateContext<AdaStateModel>, { isOpened }: UpdateAdaChatToggleState): void {
    context.patchState({ isChatOpened: isOpened, hasUnreadMessages: false });
  }

  @Action(MarkMessagesAsUnread)
  markMessagesAsUnread(context: StateContext<AdaStateModel>): void {
    const { hasUnreadMessages, isChatOpened } = context.getState();

    if (isChatOpened || hasUnreadMessages) {
      return;
    }

    context.patchState({ hasUnreadMessages: true });
  }

  @Action(SetAdaEmbedAsLoaded)
  setAdaEmbedAsLoaded(context: StateContext<AdaStateModel>): void {
    context.patchState({ isAdaEmbedLoaded: true });
  }

  @Action(SetChatAsInitialized)
  setChatAsInitialized(context: StateContext<AdaStateModel>): void {
    context.patchState({ isChatInitialized: true });
  }

  @Action(ResetConversation)
  resetConversation(context: StateContext<AdaStateModel>): void {
    context.patchState({ isChatOpened: false, hasUnreadMessages: false, isChatInitialized: false });
  }
}
